export enum UserRole {
  APPSPACE_DEV_CLUB_MEMBER = 'SICK_AS_Dev_Club_Member',
  APPPOOL_ADMIN = 'SICK_AppPool_Admin',
  MANIFEST_DEVELOPER = 'FIRMWARE_DEVELOPER',
}
